import client from './client';

export const getHomepageData = async () => {
    try { 
        const response = await client.get( "/api/homepage?populate=*")
        return response.data.data;
    } catch (error) {
        if (error.response) {
            console.error('API Error:', error.response.data);
        } else if (error.request) {
            console.error('No response from server:', error.request); // Problema de conexión
        } else {
            console.error('Error configurando la solicitud:', error.message); // Otro error
        }
        throw error;
    }
} 

export const getHeroData = async () => {
  try {
    const response = await client.get(
      "/api/homepage?populate[hero_section][populate]=image"
    );
    //console.log("API Response getHeroData: ", response.data.data.hero_section);
    return response.data.data.hero_section;
  } catch (error) {
    if (error.response) {
      console.error('API Response Error:', error.response.data);
      console.error('Status:', error.response.status);
    } else if (error.request) {
      console.error('No response from server:', error.request);
    } else {
      console.error('Error configurando la solicitud:', error.message);
    }
    throw error;
  }
};

export const getSolutionsSectionData = async () => {
    try {
      const response = await client.get(
        "/api/homepage?populate[solutions_section][populate][solutions_section_items][populate]=image"
      );
      //console.log("API Response getSolutionsSectionData: ", response.data.data.solutions_section);
      return response.data.data.solutions_section;
    } catch (error) {
      if (error.response) {
        console.error('API Response Error:', error.response.data);
        console.error('Status:', error.response.status);
      } else if (error.request) {
        console.error('No response from server:', error.request);
      } else {
        console.error('Error configurando la solicitud:', error.message);
      }
      throw error;
    }
  };

export const getAboutSectionData = async () => {
  try {
    const response = await client.get(
      "/api/homepage?populate[about_us_section][populate][team][populate]=image"
    );
    //console.log("API Response getAboutSectionData: ", response.data.data.about_us_section);
    return response.data.data.about_us_section;
  } catch (error) {
    if (error.response) {
      console.error('API Response Error:', error.response.data);
      console.error('Status:', error.response.status);
    } else if (error.request) {
      console.error('No response from server:', error.request);
    } else {
      console.error('Error configurando la solicitud:', error.message);
    }
    throw error;
  }
};

export const getValuesSectionData = async () => {
  try {
    const response = await client.get(
      "/api/homepage?populate[values_section][populate]"
    );
    //console.log("API Response getAboutSectionData: ", response.data.data.values_section);
    return response.data.data.values_section;
  } catch (error) {
    if (error.response) {
      console.error('API Response Error:', error.response.data);
      console.error('Status:', error.response.status);
    } else if (error.request) {
      console.error('No response from server:', error.request);
    } else {
      console.error('Error configurando la solicitud:', error.message);
    }
    throw error;
  }
};

export const getPartnersSectionData = async () => {
  try {
    const response = await client.get(
      "/api/homepage?populate[partners_section][populate]=images"
    );
    //console.log("API Response getPartnersSectionData: ", response.data.data.partners_section);
    return response.data.data.partners_section;
  } catch (error) {
    if (error.response) {
      console.error('API Response Error:', error.response.data);
      console.error('Status:', error.response.status);
    } else if (error.request) {
      console.error('No response from server:', error.request);
    } else {
      console.error('Error configurando la solicitud:', error.message);
    }
    throw error;
  }
};

  
